var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.3,
    height: 7.9,
    viewBox: "0 0 9.3 7.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.4c0-.4 0-.6.1-1.1v-.9c0-.1.1-.3.2-.4l3.9-3.5c0-.1-3 1.6-4.2 2.4-.3.2-.6.4-1 .6-.1 0-.1.1-.2 0C1.7 4.4 1 4.2.4 4c-.2-.1-.4-.1-.4-.3s.1-.3.3-.4L8.5.1c.3-.1.6 0 .7.1.2.1.2.3.1.6C9 2.1 7.9 7.4 7.8 7.5c-.1.4-.4.5-.7.3-.7-.5-1.3-1-2-1.5-.1-.1-.2-.1-.3 0-.3.3-.6.7-1 1-.1.1-.2.1-.3.1z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon_telegram.a884f624569e8b4531931a9a02cab4f1.svg";
export { ForwardRef as ReactComponent };